// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"50b50216","328":"ca22040f","678":"c6003135","682":"c65b77ce","731":"c95cac5a","758":"cdc4cd25","861":"75352720"}[chunkId] + ".chunk.js";
};